import { Injectable } from '../utils/DependencyInjection';
import { HttpClientAxiosInterceptedService } from './ApiKeyHttpClientAxiosInterceptedService';

@Injectable()
export class ApiKeyRestService extends HttpClientAxiosInterceptedService {
  constructor() {
    super(`https://api.sicepat.io/v1/tms-mono/monitoring/api`);
  }
}
